import React from "react";

const SubCatsIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.7"
        d="M18.5945 5.29102H4.64844V19.2371H18.5945V5.29102Z"
        fill="#7B61FF"
      />
      <path
        opacity="0.5"
        d="M16.2664 2.96582H2.32031V16.9119H16.2664V2.96582Z"
        fill="#7B61FF"
      />
      <path
        opacity="0.3"
        d="M13.9461 0.641602H0V14.5877H13.9461V0.641602Z"
        fill="#7B61FF"
      />
    </svg>
  );
};

export default SubCatsIcon;
